/**
 * Keyed by the backend's `sync_status`. Anything not listed here (null, empty,
 * an unknown state) renders nothing — most tenants have no external CRM sync,
 * so "no indicator" is the correct default.
 */
export const SYNC_STATUS_LABELS: Record<string, string> = {
  success: "Synced",
  failed: "Failed to sync",
};
